import styles from "../css/Items.module.css";
import { Dialog, DialogContent, DialogTitle, Button, Snackbar, Alert, TextField, FormControlLabel, Switch, FormControl, InputLabel, Select, MenuItem, DialogActions, Typography, RadioGroup, Radio, IconButton } from "@mui/material";
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useState, useRef, useEffect } from "react";
import heic2any from 'heic2any';
import { Grid } from "@mui/system";
import Item from "./Item";
import Wait from "./Wait";
import Confirmacion from "./Conformacion";

import miAxios from "../api/axios";
import { useAuth } from "../hooks/AuthProvider";
import CategoriasLista from "./CategoriasLista";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const soloNumeros = (texto) => {
    let nums = "0123456789."
    let res = ""
    for (var i = 0; i < texto.length; i++) {
        let s = texto[i]
        if (nums.indexOf(s) > -1) {
            res = res + s
        }
    }
    return res;
}

export default function Items(props) {
    const [procesando, setProcesando] = useState(false)
    const [openConfirmacion, setOpenConfirmacion] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [mensajeInfo, setMensajeInfo] = useState("")
    const [fotos, setFotos] = useState([]);
    const [urls, setUrls] = useState([])
    const inputRef = useRef(null);
    const [id, setId] = useState(0)
    const [descripcion, setDescripcion] = useState("")
    const [nota, setNota] = useState("")
    const [precio, setPrecio] = useState("0.00")
    const [precioLista, setPrecioLista] = useState("0.00")
    const [inactivo, setInactivo] = useState(false)
    const [categoria, setCategoria] = useState(0)
    const [openCategorias, setOpenCategorias] = useState(false)
    const [rowsCategorias, setRowsCategorias] = useState([])

    const [seleccion, setSeleccion] = useState(0)

    const user = useAuth();
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        const procesosIniciales = async () => {
            await actRowsCategorias()
        }
        procesosIniciales()
    }, [])

    useEffect(() => {
        if (props.open) {
            inicio(props.id)
        }
    }, [props.open])

    useEffect(() => {
        const n = fotos.map((foto) => {
            return {
                previewUrl: foto.previewUrl,
                zoomUrl: foto.zoomUrl
            }
        })
        setUrls(n)
    }, [fotos])

    const actRowsCategorias = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("listas/categorias-items")
            const data = response.data;
            if (data.respuesta == "S") {
                setRowsCategorias(data.datos)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleFileChange = (event) => {

        const fileList = event.target.files;
        const newPhotos = fotos.map((foto) => foto);
        let hasError = false;
        for (let i = 0; i < fileList.length; i++) {
            setProcesando(true)
            const file = fileList[i];
            const fileType = file.type;
            if (fileType === 'image/heif' || fileType === 'image/heic') {
                heic2any({
                    blob: file,
                    toType: 'image/jpeg',
                })
                    .then((jpegBlob) => {
                        const img = new Image();
                        img.onload = () => {
                            console.log("el alto es", img.height)
                            if (img.height < 1000) {
                                setMensaje(`La foto '${file.name}' es demasiado pequeña. El largo debe ser de al menos 1,000 píxeles.`);
                                event.target.value = null;
                                setProcesando(false)
                            } else {
                                if (img.width > img.height) {
                                    setMensaje(`La foto '${file.name}' tiene formato horizontal. Debe ser más alta que ancha.`);
                                    event.target.value = null;
                                    setProcesando(false)
                                } else {
                                    newPhotos.push({
                                        file: jpegBlob,
                                        previewUrl: URL.createObjectURL(jpegBlob),
                                        zoomUrl: URL.createObjectURL(jpegBlob),
                                        name: file.name.replace(/\.heic|\.heif/i, '.jpeg'),
                                        nuevo: true
                                    });

                                    setFotos(newPhotos);
                                    setProcesando(false)
                                }

                            }
                        };
                        img.src = URL.createObjectURL(jpegBlob);
                    })
                    .catch((error) => {
                        setMensaje(`Error al procesar la imagen: ${error.message}`);
                        event.target.value = null;
                    });
            } else {
                const img = new Image();
                img.onload = () => {
                    console.log("el alto es", img.height)
                    // 🟢 Valida el tamaño de la imagen
                    if (img.height < 1000) {
                        console.log("error!!!!")
                        setMensaje(`La foto '${file.name}' es demasiado pequeña. El largo debe ser de al menos 1,000 píxeles.`);
                        event.target.value = null; // Reinicia el input para permitir una nueva selección
                        hasError = true;
                        setProcesando(false)
                    } else {
                        if (img.width > img.height) {
                            setMensaje(`La foto '${file.name}' tiene formato horizontal. Debe ser más alta que ancha.`);
                            event.target.value = null;
                            hasError = true;
                            setProcesando(false)
                        } else {
                            newPhotos.push({
                                file: file,
                                previewUrl: URL.createObjectURL(file),
                                zoomUrl: URL.createObjectURL(file),
                                name: file.name,
                                nuevo: true
                            });
                            setFotos(newPhotos);
                            setProcesando(false)
                        }

                    }
                };
                img.src = URL.createObjectURL(file);
            }
        }
    };

    const handleSelectThumbnail = (event) => {
        setSeleccion(event.target.value)
    }

    const inicio = async (cual) => {
        if (cual == 0) {
            setId(0)
            setCategoria(0)
            setDescripcion("")
            setNota("")
            setPrecio("0.00")
            setPrecioLista("0.00")
            setInactivo(false)
            setFotos([])
        } else {
            setProcesando(true);
            try {
                const response = await axios.get('items/inicio?cual=' + cual);
                const data = response.data;
                console.log(data)
                setId(cual)
                setCategoria(data.datos.categoria)
                setDescripcion(data.datos.descripcion)
                setNota(data.datos.comentario)
                setPrecio(data.datos.precio)
                setPrecioLista(data.datos.precio_lista)
                setInactivo(data.datos.inactivo)
                const f = JSON.parse(data.datos.fotos)
                const n = f.map((foto) => {
                    return {
                        previewUrl: data.rutaAzure + foto.url_thumbnail,
                        zoomUrl: data.rutaAzure + foto.url_zoom,
                        nuevo: false,
                        id: foto.id
                    }
                })
                //console.log(n)
                setFotos(n)
            } catch (error) {
                console.error("Error al recuperar los archivos:", error);
                setMensaje("Error al recuperar los datos.");
            } finally {
                setProcesando(false);
            }
        }
    }

    const handleGrabar = () => {
        if (puedeGrabar()) {
            grabar()
        }
    }

    const puedeGrabar = () => {
        if (categoria == 0) {
            setMensaje("Debe seleccionar una categoria para el producto");
            return false;
        }
        if (descripcion.length == 0) {
            setMensaje("Debe digitar la descripción")
            return false;
        }
        if (parseFloat(precioLista) == 0) {
            setMensaje("Debe digitar el precio del producto")
            return false;
        }
        if (fotos.length == 0) {
            setMensaje("Debe seleccionar al menos una foto")
            return false;
        }
        return true;
    }

    const dataURLtoBlob = (dataurl) => {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    const grabar = async () => {
        setProcesando(true);
        setOpenConfirmacion(false);

        const nf = fotos.filter((f) => !f.nuevo && f.id > 0).map((f) => { return { id: f.id } })

        const data = new FormData();
        data.append("args.cual", id);
        data.append("args.categoria", categoria);
        data.append("args.descripcion", descripcion);
        data.append("args.comentario", nota);
        data.append("args.inactivo", inactivo);
        data.append("args.precio_lista", parseFloat(precioLista));
        data.append("args.precio", parseFloat(precio));
        data.append("args.url_quedan", JSON.stringify(nf))


        fotos.filter((foto) => foto.nuevo).forEach((file, index) => {
            //const imageBlob = dataURLtoBlob(file.previewUrl);
            data.append('fotos', file.file, file.name);
        });

        try {
            const response = await axios.post('items/grabar', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log("Archivos subidos exitosamente:", response.data);
            setMensajeInfo("Datos grabados exitosamente.");
            inicio(0)
        } catch (error) {
            console.error("Error al subir los archivos:", error);
            setMensaje("Error al grabar los datos.");
        } finally {
            setProcesando(false);
        }
    }

    const handleDelete = (cual) => {
        const n = fotos.filter((f, index) => index != cual).map((f) => f)
        setFotos(n)
    }

    return <>

        <Dialog open={props.open} fullWidth maxWidth="xl">
            <Snackbar
                open={mensaje.length > 0}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={() => setMensaje("")}
            >
                <Alert severity="error" onClose={() => setMensaje("")} variant="filled">
                    {mensaje}
                </Alert>
            </Snackbar>

            <Snackbar
                open={mensajeInfo.length > 0}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={() => setMensajeInfo("")}
            >
                <Alert severity="info" onClose={() => setMensajeInfo("")} variant="filled">
                    {mensajeInfo}
                </Alert>
            </Snackbar>

            <Wait procesando={procesando} />
            <CategoriasLista open={openCategorias} cerrar={() => { setOpenCategorias(false); actRowsCategorias(); }} />
            <Confirmacion open={openConfirmacion} texto="¿Desea grabar este artículo?" cancelar={() => { setOpenConfirmacion(false) }} exito={handleGrabar} />
            <DialogTitle>
                Nuestro Catálogo
            </DialogTitle>
            <DialogContent>
                <div className={styles.cuerpo}>
                    <div className={styles.col_thumbnails}>
                        <div>
                            <Button
                                size="small"
                                component="label"
                                color="coopinfa"
                                role={undefined}
                                variant="contained"
                                fullWidth
                                tabIndex={-1}
                                startIcon={<AddCircleOutlineIcon />}
                                sx={{ marginBottom: "10px" }}
                            >
                                Nueva Foto
                                <VisuallyHiddenInput
                                    type="file"
                                    onChange={handleFileChange}
                                    accept='image/*'
                                    ref={inputRef}
                                />
                            </Button>

                        </div>
                        <div className={styles.lista_thumbnails}>
                            {
                                fotos.map((foto, index) =>
                                    <div className={styles.div_thumbnails} key={index}>
                                        <div>
                                            <Radio
                                                color="coopinfa"
                                                checked={seleccion == index}
                                                value={index}
                                                onChange={handleSelectThumbnail}
                                            />
                                        </div>
                                        <div>
                                            <img
                                                src={foto.previewUrl}
                                            />
                                        </div>
                                        <div>
                                            <IconButton onClick={() => { handleDelete(index) }}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div style={{ position: "relative" }}>
                        <div className={styles.div_img}>
                            {
                                fotos[seleccion] && (
                                    <img
                                        src={fotos[seleccion].previewUrl}
                                    />
                                )
                            }

                        </div>
                    </div>
                    <div className={styles.div_datos}>
                        <Grid container spacing={1}>
                            <Grid size={12}>
                                <div className={styles.div_categoria}>
                                    <div>
                                        <FormControl color="coopinfa" fullWidth>
                                            <InputLabel id="categoria-label">Categoría</InputLabel>
                                            <Select
                                                labelId="categoria-label"
                                                size="small"
                                                value={categoria}
                                                label="Categoría"
                                                onChange={(event) => { setCategoria(event.target.value) }}
                                            >
                                                <MenuItem key={0} value={0}>{"(Seleccione)"}</MenuItem>
                                                {
                                                    rowsCategorias.map((row) => {
                                                        return <MenuItem key={row.id} value={row.id}>
                                                            {row.texto}
                                                        </MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className={styles.div_categoria_add}>
                                        <IconButton color="coopinfa" onClick={() => { setOpenCategorias(true) }}>
                                            <AddIcon />
                                        </IconButton>
                                    </div>
                                </div>

                            </Grid>
                            <Grid size={10}>
                                <TextField
                                    value={descripcion}
                                    fullWidth
                                    size="small"
                                    type="text"
                                    color="coopinfa"
                                    label="Descripción"
                                    onChange={(event) => { setDescripcion(event.target.value) }}
                                    slotProps={{
                                        inputLabel: { shrink: true }
                                    }}
                                />
                            </Grid>
                            <Grid size={2}>
                                <FormControlLabel
                                    control={<Switch size="small" checked={inactivo}
                                        color="coopinfa"
                                        onChange={(event) => { setInactivo(event.target.checked) }} />}
                                    label="Inactivo"
                                />
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    size="small"
                                    value={nota}
                                    fullWidth
                                    type="text"
                                    multiline
                                    rows={2}
                                    color="coopinfa"
                                    label="Nota"
                                    onChange={(event) => { setNota(event.target.value) }}
                                    slotProps={{
                                        inputLabel: { shrink: true }
                                    }}
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    value={precioLista}
                                    fullWidth
                                    type="text"
                                    size="small"
                                    color="coopinfa"
                                    label="Precio Lista"
                                    onChange={(event) => { setPrecioLista(soloNumeros(event.target.value)) }}
                                    slotProps={{
                                        inputLabel: { shrink: true }
                                    }}
                                    onClick={(event) => { event.target.select() }}
                                    helperText={parseFloat(precioLista || "0.00").toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    value={precio}
                                    size="small"
                                    fullWidth
                                    type="text"
                                    color="coopinfa"
                                    label="Precio Oferta"
                                    onChange={(event) => { setPrecio(soloNumeros(event.target.value)) }}
                                    slotProps={{
                                        inputLabel: { shrink: true }
                                    }}
                                    onClick={(event) => { event.target.select() }}
                                    helperText={parseFloat(precio || "0.00").toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                />
                            </Grid>
                        </Grid>
                        <div className={styles.titulo}>
                            Muestra...
                        </div>
                        <div className={styles.div_muestra}>
                            <Item
                                fotos={urls}
                                descripcion={descripcion}
                                nota={nota}
                                precioLista={precioLista}
                                precio={precio}
                            />
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => { props.cerrar() }} color="coopinfa">Cancelar</Button>
                <Button variant="contained" color="coopinfa" onClick={() => { if (puedeGrabar()) { setOpenConfirmacion(true) } }}>Grabar</Button>
            </DialogActions>
        </Dialog>
    </>

}